/** Conteneur de section : titre, consigne éventuelle, contenu. */
import type { ReactNode } from 'react';

export interface ProprietesPanneau {
  readonly titre?: string;
  readonly aide?: string;
  readonly children: ReactNode;
  readonly className?: string;
}

export function Panneau({ titre, aide, children, className }: ProprietesPanneau) {
  return (
    <section className={['panneau', className].filter(Boolean).join(' ')}>
      {titre === undefined ? null : <h2 className="panneau__titre">{titre}</h2>}
      {aide === undefined ? null : <p className="panneau__aide">{aide}</p>}
      {children}
    </section>
  );
}
